/**
 * Jaipur Handloom responsive interaction helpers — 18AE10
 *
 * Sole owner of mobile predictive-search placement and responsive viewport
 * measurements. Mobile navigation moved to jh-10-navigation.js so only one
 * controller can open or close the menu.
 */
(function() {
  'use strict';

  var JH = window.JH || {};
  var Utils = JH.Utils;
  if (!Utils) return;

  function isMobile() {
    return !window.matchMedia || window.matchMedia('(max-width: 900px)').matches;
  }

  function setViewportHeight() {
    var height = window.innerHeight || document.documentElement.clientHeight || 0;
    if (height) document.documentElement.style.setProperty('--jh-vh', height + 'px');
  }

  function setMobileSearchTop(root) {
    if (!root || !isMobile()) return;
    var input = Utils.qs('[data-jh-search-input]', root) || Utils.qs('input[type="search"]', root);
    if (!input) return;
    document.documentElement.style.setProperty(
      '--jh-mobile-search-top',
      Math.max(58, Math.round(input.getBoundingClientRect().bottom + 8)) + 'px'
    );
  }

  function closeSearch(root, markDismissed) {
    if (!root) return;
    var input = Utils.qs('[data-jh-search-input]', root);
    var panel = Utils.qs('[data-jh-search-panel]', root);
    if (markDismissed !== false) root.dataset.jhSearchDismissed = 'true';
    root.classList.remove('jh-search-has-query');
    if (input) input.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }
  }

  function openSearch(root, forceOpen) {
    if (!root) return;
    if (!forceOpen && root.dataset.jhSearchDismissed === 'true') return;
    setMobileSearchTop(root);
    var input = Utils.qs('[data-jh-search-input]', root);
    var panel = Utils.qs('[data-jh-search-panel]', root);
    root.classList.add('jh-search-has-query');
    if (input) input.setAttribute('aria-expanded', 'true');
    if (panel) {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }
  }

  function syncMobileSearch(root) {
    if (!root) return;
    if (!isMobile()) {
      root.classList.remove('jh-search-has-query');
      return;
    }
    var input = Utils.qs('[data-jh-search-input]', root) || Utils.qs('input[type="search"]', root);
    var panel = Utils.qs('[data-jh-search-panel]', root);
    var hasQuery = !!(input && String(input.value || '').trim());
    var isActive = !!(input && document.activeElement === input);
    var isAlreadyOpen = !!(panel && panel.classList.contains('is-open'));
    var isDismissed = root.dataset.jhSearchDismissed === 'true';
    if (hasQuery && !isDismissed && (isActive || isAlreadyOpen)) openSearch(root);
    else closeSearch(root, false);
  }

  function initMobileSearch(scope) {
    Utils.qsa('[data-jh-search-root]', scope || document).forEach(function(root) {
      if (root.dataset.jhResponsiveSearchReady === 'true') return;
      root.dataset.jhResponsiveSearchReady = 'true';

      var input = Utils.qs('[data-jh-search-input]', root) || Utils.qs('input[type="search"]', root);
      if (!input) return;

      if (typeof root.dataset.jhSearchDismissed === 'undefined') root.dataset.jhSearchDismissed = 'true';

      input.addEventListener('focus', function() {
        root.dataset.jhSearchDismissed = 'false';
        if (isMobile() && String(input.value || '').trim()) openSearch(root, true);
      }, true);

      input.addEventListener('input', function() {
        root.dataset.jhSearchDismissed = 'false';
        syncMobileSearch(root);
      }, true);

      input.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          closeSearch(root);
          input.blur();
        }
      }, true);
    });
  }

  function resetHorizontalRows(scope) {
    Utils.qsa('[data-jh-scroll-row], [data-jh-reco-row], [data-jh-hero-gallery-track]', scope || document).forEach(function(row) {
      row.dir = 'ltr';
      try { row.scrollLeft = 0; } catch (error) {}
    });
  }

  function initHeroTapOverlay(scope) {
    Utils.qsa('.jh-hero-gallery-v1317__slide', scope || document).forEach(function(slide) {
      if (slide.dataset.jhHeroTapReady === 'true') return;
      slide.dataset.jhHeroTapReady = 'true';
      slide.addEventListener('click', function(event) {
        if (!isMobile() || event.target.closest('.jh-hero-gallery-v1317__quick, .jh-hero-gallery-v1317__hover')) return;
        if (slide.classList.contains('is-info-open')) return;
        event.preventDefault();
        Utils.qsa('.jh-hero-gallery-v1317__slide.is-info-open').forEach(function(other) {
          if (other !== slide) other.classList.remove('is-info-open');
        });
        slide.classList.add('is-info-open');
      }, true);
    });
  }

  function initBlogSearch(scope) {
    Utils.qsa('.jh-bloghub-search', scope || document).forEach(function(input) {
      if (input.dataset.jhEnhanced === '1') return;
      input.dataset.jhEnhanced = '1';
      input.addEventListener('input', function() {
        var query = String(input.value || '').toLowerCase().trim();
        Utils.qsa('.jh-bloghub-card').forEach(function(card) {
          card.classList.toggle('is-hidden', !!query && String(card.textContent || '').toLowerCase().indexOf(query) === -1);
        });
      });
    });
  }

  function secureExternalLinks(scope) {
    Utils.qsa('a[target="_blank"]', scope || document).forEach(function(link) {
      var rel = String(link.rel || '');
      if (!/\bnoopener\b/.test(rel)) rel += (rel ? ' ' : '') + 'noopener';
      if (!/\bnoreferrer\b/.test(rel)) rel += (rel ? ' ' : '') + 'noreferrer';
      link.rel = rel.trim();
    });
  }

  function boot(scope) {
    document.documentElement.classList.add('jh-clean-release');
    setViewportHeight();
    initMobileSearch(scope || document);
    initHeroTapOverlay(scope || document);
    initBlogSearch(scope || document);
    secureExternalLinks(scope || document);
    resetHorizontalRows(scope || document);
  }

  Utils.ready(function() { boot(document); });
  document.addEventListener('shopify:section:load', function(event) {
    window.setTimeout(function() { boot(event.target); }, 100);
  });

  function eventIsInsideRoot(event, root) {
    if (typeof event.composedPath === 'function' && event.composedPath().indexOf(root) !== -1) return true;
    return !!(event.target && root.contains(event.target));
  }

  function closeSearchesOutside(event) {
    Utils.qsa('[data-jh-search-root]').forEach(function(root) {
      if (!eventIsInsideRoot(event, root)) closeSearch(root, true);
    });
  }

  document.addEventListener('pointerdown', closeSearchesOutside, true);
  document.addEventListener('mousedown', closeSearchesOutside, true);
  document.addEventListener('touchstart', closeSearchesOutside, { capture: true, passive: true });
  document.addEventListener('click', closeSearchesOutside, true);
  document.addEventListener('focusin', closeSearchesOutside, true);

  window.addEventListener('resize', Utils.debounce(function() {
    setViewportHeight();
    Utils.qsa('[data-jh-search-root]').forEach(syncMobileSearch);
  }, 100), { passive: true });

  window.addEventListener('orientationchange', function() {
    window.setTimeout(function() {
      setViewportHeight();
      Utils.qsa('[data-jh-search-root]').forEach(function(root) {
        var panel = Utils.qs('[data-jh-search-panel]', root);
        if (panel && panel.classList.contains('is-open')) setMobileSearchTop(root);
      });
    }, 250);
  }, { passive: true });
})();
